import { CustomerLiteModel, useGetCustomers } from 'api-hooks/customer';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { transformLabel } from 'common/utils/string';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

function transformer(item: CustomerLiteModel): Option {
  return {
    id: item.id,
    label: transformLabel([item.name, item.alias]) + ` (${item.phone})`,
  };
}

export interface CustomerFilterSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
  required?: boolean;
}

export default function CustomerFilterSelectInput(
  props: CustomerFilterSelectInputProps,
) {
  const { t } = useTranslation();
  const {
    label = t('common:customer'),
    placeholder = t('common:select_customer'),
    value,
    onSelected,
    required,
  } = props;

  const query = useGetCustomers({
    params: {
      limit: -1,
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.CustomerMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  return (
    <CustomFormControl
      label={label}
      noMargin={props.noMargin}
      required={_required}
    >
      <Select
        type="select"
        placeholder={placeholder}
        options={options}
        value={_value}
        required={_required}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
